import { render } from "./CreateProject.vue?vue&type=template&id=4123aeef&scoped=true"
import script from "./CreateProject.vue?vue&type=script&lang=js"
export * from "./CreateProject.vue?vue&type=script&lang=js"

import "./CreateProject.vue?vue&type=style&index=0&id=4123aeef&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4123aeef"]])

export default __exports__